import { httpGet, httpPut, httpPost } from '../../Util/http';
import { addAlert } from '../../MsgNotify/msgNotifyActions';
import update from 'react/lib/update';

import auth from '../../Login/authService'

export const KANBAN_SET_INIT_STATE = 'KANBAN_SET_INIT_STATE';
export function setInitState(showSidebar) {
    return {
        type: KANBAN_SET_INIT_STATE,
        showSidebar
    }
}



export const GET_WORKPLACES_REQUEST = 'GET_WORKPLACES_REQUEST'
export const getWorkplacesRequest = () => {
    return {
        type: GET_WORKPLACES_REQUEST
    }
}

export const GET_WORKPLACES_SUCCESS = 'GET_WORKPLACES_SUCCESS';
export function getWorkplacesSuccess(json, departmentId) {
    let organ = json.workplaceOrganizer
    if (json.workplaceOrganizer.length === 9) {
        json.workplaceOrganizer.splice(8, 0, { items: [] });
    }
    return {
        type: GET_WORKPLACES_SUCCESS,
        workplaces: json.workplaces,
        organizer: organ,
        unread: json.unread,
        departmentName: json.departmentName,
        departmentId: departmentId
    }
}

export const GET_WORKPLACES_FAILURE = 'GET_WORKPLACES_FAILURE'
export function getWorkplacesFailure() {
    return {
        type: GET_WORKPLACES_FAILURE
    };
}

export const ADD_UNREAD_CHATMESSAGE = 'ADD_UNREAD_CHATMESSAGE'
export function addUnreadChatMessageInKanban(workplaceId) {
    return {
        type: ADD_UNREAD_CHATMESSAGE,
        workplaceId: workplaceId
    };
}

export const SET_SHOW_OWN_WORKPLACES = 'SET_SHOW_OWN_WORKPLACES';
export const setShowOwnWorkplaces = (showOwnWorkplaces) => {
    return {
        type: SET_SHOW_OWN_WORKPLACES,
        showOwnWorkplaces: showOwnWorkplaces
    }
}

export const SET_PROJECT_SUGGESTION_VALUE = 'SET_PROJECT_SUGGESTION_VALUE';
export const setProjectSuggestionValue = (projectSuggestionValue) => {
    return {
        type: SET_PROJECT_SUGGESTION_VALUE,
        projectSuggestionValue: projectSuggestionValue
    }
}

export const UPDATE_WORKPLACE_COLOR = 'UPDATE_WORKPLACE_COLOR';
export const updateWorkplaceColor = (workplaceId, color) => {
    return {
        type: UPDATE_WORKPLACE_COLOR,
        color,
        workplaceId
    }
}

export const REMOVE_EMPLOYEE_FROM_WORKPLACE = 'REMOVE_EMPLOYEE_FROM_WORKPLACE';
export const removeEmployeeFromWorkplace = (workplaceId, employeeId) => {
    return (dispatch, getState) => {
        let employees = getState().kanbanReducer.workplaces[workplaceId].employees
        delete employees[employeeId]
        dispatch({
            type: REMOVE_EMPLOYEE_FROM_WORKPLACE,
            workplaceId,
            employees
        })
    }
}


export function attemptGetWorkplaces(departmentId, wipeStore = true) {
    var _url = process.env.REACT_APP_webApiEndPoint + 'api/workplace/department/' + departmentId
    return (dispatch, getState) => {
        if (auth.getProfile().role === "Formand" && !getState().kanbanReducer.updatedAt) {
            dispatch(setColumnsShowing(3, 6))
        }

        if (wipeStore) {
            dispatch(getWorkplacesRequest());
        }
        return httpGet(_url)
            .then(response => {
                return response.json();
            })
            .then(json => {
                dispatch(getWorkplacesSuccess(json, departmentId))
            }).catch((e) => {
                dispatch(getWorkplacesFailure())
                dispatch(addAlert(e.message))
            })
    };
}


export const ADD_EMPLOYEE_TO_WORKPLACE = 'ADD_EMPLOYEE_TO_WORKPLACE';
export const addEmployeeToWorkplace = (employee, workplaceId) => (
    {
        type: ADD_EMPLOYEE_TO_WORKPLACE,
        employee,
        workplaceId
    }
)



export const SET_WORKPLACE_IS_DRAGGING = 'SET_WORKPLACE_IS_DRAGGING'
export function setWorkplaceIsDragging(workplaceId) {
    return {
        type: SET_WORKPLACE_IS_DRAGGING,
        workplaceId
    };
}


export const UPDATE_WORKPLACE_ORGANIZER = 'UPDATE_WORKPLACE_ORGANIZER'
export function updateWorkplaceOrganizer(organizer) {
    return {
        type: UPDATE_WORKPLACE_ORGANIZER,
        organizer
    };
}

export const UPDATE_INVOICED_WORKPLACE = 'UPDATE_INVOICED_WORKPLACE'
export function updateInvoicedWorkplace(workplaceId, invoiced) {
    return {
        type: UPDATE_INVOICED_WORKPLACE,
        workplaceId: workplaceId,
        invoiced: invoiced
    };
}




export function onWorkplaceDrop(workplaceId, columnId, index, oldColumnId, oldIndex) {

    let _url = process.env.REACT_APP_webApiEndPoint + 'api/workplace/' + workplaceId + '/move';
    const newIndex = (index > oldIndex && columnId === oldColumnId) ? index - 1 : index

    return (dispatch, getState) => {
        // if (oldColumnId === 0) {
        //     const _rl = process.env.REACT_APP_webApiEndPoint + 'api/arbejdsmiljo/' + workplaceId + '/save';
        //     httpGet(_rl)
        //         .then(resp => resp.json())
        //         .then((json) => {
        //             if (!json) {
        //                 alertApv(dispatch);
        //             }
        //             let a = JSON.parse(json.documentState)
        //             if (Object.keys(a.selected).length == 0) {
        //                 alertApv(dispatch);
        //             }
        //         })
        //         .then(() => {
        //             return moverr(getState, dispatch);
        //         })
        //         .catch(() => {
        //             //
        //         })
        // } else {
        return moverr(getState, dispatch);
        // }
    };

    // function alertApv(dispatch) {
    //     if (auth.getProfile().role === 'Formand') {
    //         alert('En funktionær skal tilknytte APV til arbejdsstedet');
    //     }
    //     else {
    //         alert('Du skal tilknytte mindst én APV til arbejdsstedet');
    //         dispatch(routeActions.push(window.location.pathname + '/arbejdssted/' + workplaceId + '/arbejdsmiljo'));
    //     }
    //     throw new Error();
    // }


    function moverr(getState, dispatch) {
        let oldOrganizer = getState().kanbanReducer.organizer;
        let newOrganizer = updateOrganizer(oldOrganizer, workplaceId, columnId, index, oldColumnId, oldIndex);
        dispatch(updateWorkplaceOrganizer(newOrganizer));
        dispatch(updateInvoicedWorkplace(workplaceId, columnId === 8));
        return httpPut(_url, { WorkplaceOrganizer: newOrganizer, state: columnId, index: newIndex })
            .catch((e) => {
                dispatch(updateInvoicedWorkplace(workplaceId, oldColumnId === 8));
                dispatch(updateWorkplaceOrganizer(oldOrganizer));
                dispatch(addAlert(e.message));
            });
    }
}

//helper function to update the organizer to the new state
const updateOrganizer = (oldOrganizer, workplaceId, columnId, index, oldColumnId, oldIndex) => {

    let newOrganizer1 = update(oldOrganizer, {
        [oldColumnId]: {
            items: {
                $splice: [[oldIndex, 1]]
            }
        }
    });
    let newOrganizer = update(newOrganizer1, {
        [columnId]: {
            items: {
                $splice: [[(index > oldIndex && columnId === oldColumnId) ? index - 1 : index, -1, workplaceId]]
            }
        }
    });
    return newOrganizer;
}


export function onWorkplaceEmployeeDrop(employee, workplaceId) {

    let url = process.env.REACT_APP_webApiEndPoint + 'api/workplace/' + workplaceId + '/addemployee';

    return (dispatch) => {
        const _url = process.env.REACT_APP_webApiEndPoint + 'api/arbejdsmiljo/' + workplaceId + '/save';
        let ok = false
        return httpGet(_url)
            .then(resp => resp.json())
            .then((json) => {
                if (!json) {
                    return
                }
                let rep = JSON.parse(json.documentState)
                if (rep) {
                    if (rep.selected) {
                        ok = Object.keys(rep.selected).length > 0
                    }
                }
            })
            .then(() => {
                if (ok) {
                    return httpPut(url, { id: employee.id })
                        .then(() => {
                            dispatch(addEmployeeToWorkplace(employee, workplaceId))
                        })
                        .catch((e) => {
                            console.error(e);
                            dispatch(addAlert("Kunne ikke tilføje medarbejderen til arbejdsstedet"))
                        })
                } else {
                    alert('Arbejdssted skal mindst have 1 gældende apv tildelt, før medarbejdere kan tildeles')
                }
            })
    };
}


export const GET_PROJECT_SUGGESTIONS_SUCCESS = 'GET_PROJECT_SUGGESTIONS_SUCCESS';
export function getProjectSuggestionsSuccess(suggestions) {
    return {
        type: GET_PROJECT_SUGGESTIONS_SUCCESS,
        suggestions: suggestions
    }
}

export const SEARCH_WORKPLACES_MATCHES = 'SEARCH_WORKPLACES_MATCHES';
export function setMatchedWorkplaces(matches) {
    return {
        type: SEARCH_WORKPLACES_MATCHES,
        matches
    }
}

function searchWorkplace(searchArray, array) {
    let allQ = []
    array.forEach((n) => {
        searchArray.forEach((query) => {
            if (n.toLowerCase().includes(query)) { allQ.push(true) }
        })
    })
    return allQ.length === searchArray.length
}

export function getProjectSuggestions(val) {
    return (dispatch, getState) => {
        if (val === '')
            dispatch(setMatchedWorkplaces([]))

        val = val.toLowerCase()
        val = val.split(' ').filter(v => v)
        let matches = []
        let workplaces = getState().kanbanReducer.workplaces
        for (var prop in workplaces) {
            let workplace = workplaces[prop]
            let match = false
            let client = workplace.client || { name: '', contact: {name: ''}}
            match = searchWorkplace(val, workplace.name.split(' '))
            if (!match)
                match = searchWorkplace(val, client.name.split(' '))
            if (!match)
                match = searchWorkplace(val, client.contact.name.split(' '))
            if (!match)
                match = searchWorkplace(val, workplace.project.name.split(' '))
            if (!match)
                match = searchWorkplace(val, workplace.project.number.split(' '))

            if (match)
                matches.push(workplace.id)
        }
        if (matches.length > 0)
            dispatch(setMatchedWorkplaces(matches))
        else
            dispatch(setMatchedWorkplaces(['MUNIES']))

    };
}


export const SET_COLUMNS_SHOWING = 'SET_COLUMNS_SHOWING';
export const setColumnsShowing = (from, to) => (
    {
        type: SET_COLUMNS_SHOWING,
        from,
        to
    }
)


export const ADD_MISSING_WORKPLACES = 'ADD_MISSING_WORKPLACES';
export const addMissingWorkplaces = (workplaces) => (
    {
        type: ADD_MISSING_WORKPLACES,
        workplaces
    }
)


export function attemptGetMissingWorkplaces(workplaceIds) {
    var _url = process.env.REACT_APP_webApiEndPoint + 'api/workplace/workplaces';
    return dispatch => {
        return httpPost(_url, { workplaceIds: workplaceIds })
            .then(response => {
                return response.json();
            })
            .then(json => {
                dispatch(addMissingWorkplaces(json.workplaces))
            }).catch((e) => {
                dispatch(addAlert(e.message))
            })
    };
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/actions.js